import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'amfe-flexible/index.js'
import VueDND from 'awe-dnd'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
Vue.use(ElementUI)
Vue.prototype.axios = axios

Vue.config.productionTip = false
// 引入组件
// 添加至全局
Vue.use(VueDND)

new Vue({
  render: h => h(App),
}).$mount('#app')
